import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getSEO, updateSEO } from '@/services/productDetail';
import FooterToolBar from '@/components/tool/FooterToolBar';
export default {
  components: {
    FooterToolBar: FooterToolBar
  },
  props: {
    productId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      initDataForm: {
        id: 0,
        SEOList: []
      },
      queryLoading: false,
      tabKey: '0',
      dataForm: {
        id: 0,
        SEOList: []
      },
      rules: {},
      specFlag: undefined
    };
  },
  created: function created() {
    //初始化
    this.getInitialValue();
  },
  methods: {
    //初始化
    getInitialValue: function getInitialValue() {
      var _this = this;
      var self = this;
      // self.queryLoading = true;

      //获取商品id
      self.dataForm.id = self.productId;

      //获取多语言
      self.dataForm.SEOList = [];
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //多语言id
          nameObj.langId = item.langId;
          //名称
          nameObj.langName = item.langName;
          nameObj.title = "";
          nameObj.keyword = "";
          nameObj.desc = "";
          nameObj.speclist = [];
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
            self.tabKey = nameObj.langId;
          } else {
            nameObj.required = false;
          }
          self.dataForm.SEOList.push(nameObj);
        }

        //获取seo详情
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (self.productId > 0) {
        getSEO(self.dataForm.id).then(function (res) {
          if (res.data.code == 200) {
            var rs = res.data.data;
            _this.specFlag = res.data.data.specFlag;
            // let rs = {
            // 	public:[],
            // 	speclist:[]
            // }
            // let rs = {
            // 	public:[
            // 		{
            // 			langId:'3',
            // 			title:'前端造日本语',
            // 			keyword:'关键字日本语',
            // 			desc:'描述日本语'
            // 		}
            // 	],
            // 	speclist:[
            // 		{
            // 			specId:'2',
            // 			specValue:'假造规格值1',
            // 			keywordslist:[
            // 				{
            // 					langId:'3',
            // 					keyword:'规格值日文11'
            // 				},
            // 				{
            // 					langId:'2',
            // 					keyword:'规则值中文11'
            // 				}
            // 			]
            // 		},
            // 		{
            // 			specId:'3',
            // 			specValue:'假造规格值2',
            // 			keywordslist:[
            // 				{
            // 					langId:'3',
            // 					keyword:'规格值日文22'
            // 				},
            // 				{
            // 					langId:'2',
            // 					keyword:'规则值中文22'
            // 				}
            // 			]
            // 		}

            // 	]
            // }
            //							console.log(rs.length);
            // 公共的
            if (rs.publiclist.length > 0) {
              var _iterator2 = _createForOfIteratorHelper(self.dataForm.SEOList),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var item = _step2.value;
                  var _iterator3 = _createForOfIteratorHelper(rs.publiclist),
                    _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      var one = _step3.value;
                      if (item.langId == one.langId) {
                        item.title = one.title;
                        item.keyword = one.keyword;
                        item.desc = one.desc;
                        break;
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
            // 按照规格值的
            if (rs.speclist.length > 0) {
              // 循环语言
              var _iterator4 = _createForOfIteratorHelper(self.dataForm.SEOList),
                _step4;
              try {
                var _loop = function _loop() {
                  var item = _step4.value;
                  // 循环规格值
                  var _iterator5 = _createForOfIteratorHelper(rs.speclist),
                    _step5;
                  try {
                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                      var item2 = _step5.value;
                      var specObj = {};
                      // 把与当前语言一样的keyword 提取出来
                      var nowKeyword = item2.speclanglist.filter(function (item3) {
                        return item3.langId == item.langId;
                      });
                      specObj.keyword = nowKeyword.length > 0 ? nowKeyword[0].keyword : '';
                      specObj.specvalueId = item2.specvalueId;
                      specObj.specvalue = item2.specvalue;
                      item.speclist.push(specObj);
                    }
                  } catch (err) {
                    _iterator5.e(err);
                  } finally {
                    _iterator5.f();
                  }
                };
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  _loop();
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }
            console.log(self.dataForm.SEOList, 'seo');
            //保存后重新初始化，切换tab验证用
            self.initDataForm = _.cloneDeep(self.dataForm);
          } else {
            self.$notification.error({
              message: res.data.message
            });
          }
          // self.queryLoading = false;
        });
      }
    },
    //tabs 切换事件
    tabChange: function tabChange(activeKey) {
      var self = this;
      self.tabKey = activeKey;
    },
    //保存
    saveData: function saveData() {
      var self = this;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          //调接口
          self.queryLoading = true;
          var newData = _.cloneDeep(self.dataForm);
          var newSpeclist = [];
          // 为了分规格值来存
          var falseKeywordlist = [];
          var falsespecId = [];
          var specLen = newData.SEOList[0].speclist.length;
          console.log(specLen);
          if (specLen > 0) {
            console.log(111);
            for (var i = 0; i < specLen; i++) {
              falseKeywordlist.push([]);
              falsespecId.push('');
            }
            // 外层循环是语言的循环
            newData.SEOList.forEach(function (item) {
              // 内层循环是规格的循环
              item.speclist.forEach(function (item2, index) {
                var newSpecobj = {
                  specvalueId: '',
                  speclanglist: []
                };
                // 根据规格值来赋值 这样不同规格值内容不一样
                falsespecId[index] = item2.specvalueId;
                newSpecobj.specvalueId = falsespecId[index];
                // 将这个规格值对应的多语言的keyword添加进去 falseKeywordlist再最外面 所以能保证拿到所有语言的keyword
                falseKeywordlist[index].push({
                  langId: item.langId,
                  keyword: item2.keyword
                });
                newSpecobj.speclanglist = falseKeywordlist[index];
                newSpeclist[index] = newSpecobj;
              });
            });
          }
          var params = {
            id: newData.id,
            publicList: newData.SEOList.map(function (item) {
              return {
                langId: item.langId,
                title: item.title,
                keyword: item.keyword,
                desc: item.desc
              };
            }),
            speclist: newSpeclist
          };
          console.log(params, 'params............');
          //  转化传参的格式

          updateSEO(params).then(function (result) {
            if (result.data.code == 200) {
              self.initDataForm = _.cloneDeep(self.dataForm);
              self.$message.success(self.$t('public.saveSuccessfully'));
            }
            self.queryLoading = false;
          }).finally(function () {
            self.queryLoading = false;
          });
        } else {
          self.queryLoading = false;
          console.log('error submit!!');
          return false;
        }
      });
    },
    check: function check() {
      if (JSON.stringify(this.initDataForm) != JSON.stringify(this.dataForm)) {
        return false;
      } else {
        return true;
      }
    }
  }
};